import { render, staticRenderFns } from "./BatchShipmentView.vue?vue&type=template&id=976b8f5c&"
import script from "./BatchShipmentView.vue?vue&type=script&lang=js&"
export * from "./BatchShipmentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports